import { useRef, useState } from 'react';
import { Row, Col, Card } from "react-bootstrap";
import { TextButton, IconTextButton } from 'Components/Button';
import { ICONS } from "Utils/icons";
import { HOSPITALV1_2_DATA } from './HospitalV1_2Data';
import { LeftPageHeader } from 'Components/Public/PageHeader/PageHeader';
import CommonFormatsBody from "../../../Components/Public/CommonFormats/CommonFormatsBody";
import { handleFileDownload } from 'Utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { setGlobalErrorStatus } from "../../../Components/StatusHandling";
import { ERROR_MESSAGES } from "../../../Utils/constants";
import Feedback from "../../../Components/Public/Feedback/Feedback";

const HospitalV1_2 = () => {
  const dispatch = useDispatch();
  const sectionRefs = useRef({});

  const [downloadingFiles, setDownloadingFiles] = useState([]);
  const allResourceGroupId = "2851";
  const COLLECT_DATA_ALL_RESOURCE_GROUPID = "2850";
  const SUBMIT_DATA_ALL_RESOURCE_GROUPID = "2849";

  // scroll into view by useRef key: 
  // key: "level1-1"
  const scrollTo = (key) => {
    sectionRefs.current[key]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const downloadFile = (groupId) => {
    //console.log(downloadingFiles);
    if (downloadingFiles.includes(groupId)) {

    }
    else {
      setDownloadingFiles([...downloadingFiles, groupId]);
      handleFileDownload(
        groupId,
        () => {
          //console.log(document.activeElement);
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.GENERAL_ERROR.title,
              msg: ERROR_MESSAGES.GENERAL_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          })
        },
        () => {
          setDownloadingFiles(downloadingFiles.filter(f => f == groupId))
        }
      );
    }

  }
  return (
    <>
      <LeftPageHeader
        subTitle="COMMON FORMATS"
        title="Hospital Version 1.2"
        intro="Note: This is not the latest Common Format for hospitals. Hospital Version 2.0 simplifies modules, separates core and supplemental data, and refines event categories for improved clarity and interoperability."
        rightContent={
          <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content     ms-auto me-auto h-100 justify-content-center mt-2 mb-2">
            {/* comment below for future use
            <TextButton
              variant={"normal"}
              //onClick={}
              content={"Explore Data Elements"}
              className="button-width"
            />
            */}
            <IconTextButton
              className="reverse button-width text-center w-100 d-flex justify-content-center"
              icon={ICONS.download}
              onClick={() => downloadFile(allResourceGroupId)}
              variant="outline-clear"
              content={"Download all Resources"}
            />

          </div>
        }
      >
        <h2 className="public-title text-center mb-3">Use this Common Format to:</h2>
        <Row className="blue-text public-cards col-gap-2 row-gap-5">
          <Col className="" md={6}>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column align-items-start">
                <div className="d-flex flex-column flex-lg-row align-items-start gap-3">
                  <div className="number-bg align-items-center">
                    <div className="mb-1"><span className="displayXS semibold">1</span></div>
                  </div>
                  <div className="">
                    <div className="text-start mb-2"><span className="public-card-header horizontal ">Collect Data</span></div>
                    <div className="public-card-content ">
                      <p>Use the Hospital Version 1.2 Common Format to gather safety event data from your providers using AHRQ-defined best practices.</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column gap-3 w-xs-100 w-md-fit-content h-100 justify-content-end ms-auto me-auto">
                  <TextButton
                    variant={"normal"}
                    onClick={() => scrollTo("level1-1")}
                    content={"Learn More"}
                    className="button-width"
                  />
                  <IconTextButton
                    className="reverse button-width text-center w-100 d-flex justify-content-center"
                    icon={ICONS.download}
                    onClick={() => downloadFile(COLLECT_DATA_ALL_RESOURCE_GROUPID)}
                    variant="outline"
                    content={"Download Resources"}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col className="" md={6}>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column align-items-start">
                <div className="d-flex flex-column flex-lg-row align-items-start gap-3">
                  <div className="number-bg align-items-center">
                    <div className="mb-1"><span className="displayXS semibold">2</span></div>
                  </div>
                  <div>
                    <div className="text-start mb-2"><span className="public-card-header horizontal ">Submit Data</span></div>
                    <div className="public-card-content ">
                      <p>Contribute to national learning about safety events by sharing that data to the PSOPPC using the Hospital Version 1.2 Common Format.</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column gap-3 w-xs-100 w-md-fit-content h-100 justify-content-end ms-auto me-auto">
                  <TextButton
                    variant={"normal"}
                    onClick={() => scrollTo("level1-2")}
                    content={"Learn More"}
                    className="button-width"
                  />
                  <IconTextButton
                    className="reverse button-width text-center w-100 d-flex justify-content-center"
                    icon={ICONS.download}
                    onClick={() => downloadFile(SUBMIT_DATA_ALL_RESOURCE_GROUPID)}
                    variant="outline"
                    content={"Download Resources"}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </LeftPageHeader>
      <CommonFormatsBody commonFormatsData={HOSPITALV1_2_DATA} ref={sectionRefs} />
      <Feedback/>
    </>
  )
};

export default HospitalV1_2;